export class PaymentModel {
    public Id :string;
    public CompanyImagePath : string;
    public CompanyName : string;
    public CompanyWebSite : string;
    public ProcessDataName:string;
    public InstallmentName : string;
    public InstallmentPrice : string;
    public PaymentDate : string;
    public PaymentPrice : string;
}